import React from 'react';
import { Radio, Select, Input, InputNumber, Row, Col, message } from 'antd'
import { InputType, WidthType, RegularExpression } from './input-const';

const RadioGroup = Radio.Group;

//最小宽度
const minWidth = 1;

/**
 * 多行文本输入控件配置组件
 * Author: zengxiangkai@ly-sky.com
 * Created on: 2018-02-05 19:21:51
 * Version: 1.0
 * Modify log:
 */
class SettingTextArea extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            feature: '', //原参数json字符串
            width: minWidth, //设置的宽度值，初始为最小宽度值
            featureParams: {
                type: InputType.TEXTAREA, //控件类型，必须有此属性，用于渲染时期判断控件类型
                widthType: WidthType.DEFAULT, //宽度类型：自适应'default'、百分比'relative'、固定值'fixed'
                widthStr: '', //input宽度值
                patternTag: '', //正则表达式标识
                placeholder: '', //输入提示
                required: false, //是否必须
                defaultValue: '' //默认值
            },
            selectOptions: []
        }
    }

    static defaultProps = {
        initFeature: ''
    }

    //在渲染前调用,可在此最后一次初始化组件状态
    componentWillMount() {
        //将输入控件配置参数设置到状态中
        if (this.props.initFeature) {
            try {
                let initFeature = JSON.parse(this.props.initFeature);
                if (initFeature.type == InputType.TEXTAREA) {
                    let { widthType, widthStr = '', patternTag = '', placeholder = '', required = false,
                        defaultValue = '' } = initFeature;

                    let width = '';

                    if (widthType == WidthType.RELATIVE) {
                        width = widthStr.replace('%', '');
                    } else if (widthType == WidthType.FIXED) {
                        width = widthStr.replace('px', '');
                    }
                    const fp = { ...this.state.featureParams };
                    fp.widthType = widthType;
                    fp.widthStr = widthStr;
                    fp.patternTag = patternTag;
                    fp.placeholder = placeholder;
                    fp.required = required;
                    fp.defaultValue = defaultValue;
                    this.setState({
                        feature: this.props.initFeature,
                        width: width,
                        featureParams: fp
                    });
                }

            } catch (e) {
                console.log(e);
                message.error('解析控件配置参数出错！');
            }
        } else {
            try {
                let feature = JSON.stringify(this.state.featureParams);
                this.setState({
                    feature: feature
                });
            } catch (e) {
                console.log(e);
                message.error('生成控件配置参数出错！');
            }
        }
        const Option = Select.Option;
        //构建正则表达式下拉数据
        let selectOptions = [<Option key={-1} value="">请选择...</Option>];
        for (let key in RegularExpression) {
            let option = (<Option key={key} value={key}>{RegularExpression[key].describe}</Option>);
            selectOptions.push(option);
        }
        this.setState({ selectOptions: selectOptions });
    }

    //供父组件获取feature
    getFeature = () => {
        return this.state.feature;
    }

    //切换宽度类型radio时回调，清空之前的值
    handleWidthRadioChange = (e) => {
        let widthType = e.target.value;

        const fp = { ...this.state.featureParams };
        fp.widthType = widthType;
        fp.widthStr = '';

        this.setState({ width: '', featureParams: fp });
        this.createFeature(fp);
    }

    //宽度值改变的时候，同步更新状态参数
    handleWidthChange = (value) => {
        let widthStr;
        let widthType = this.state.featureParams.widthType;

        if (widthType == WidthType.RELATIVE) {
            widthStr = value + '%';
        } else if (widthType == WidthType.FIXED) {
            widthStr = value + 'px';
        } else {
            widthStr = '';
        }

        const fp = { ...this.state.featureParams };
        fp.widthStr = widthStr;

        this.setState({ width: value, featureParams: fp });
        this.createFeature(fp);
    }

    //是否必填
    handleRequiredRadioChange = (e) => {
        let required = e.target.value;

        const fp = { ...this.state.featureParams };
        fp.required = required;

        this.setState({ featureParams: fp });
        this.createFeature(fp);
    }

    //当选中正则表达式改变后
    handleRegularChange = (value) => {
        const fp = { ...this.state.featureParams };
        fp.patternTag = value;

        this.setState({ featureParams: fp });
        this.createFeature(fp);
    }

    //当输入的提示信息改变时
    handlePlaceholderChange = (e) => {
        let placeholder = e.target.value;
        const fp = { ...this.state.featureParams };
        fp.placeholder = placeholder;
        this.setState({ featureParams: fp });
        this.createFeature(fp);
    }

    //当输入默认值改变时
    handleDefaultValueChange = (e) => {
        let defaultValue = e.target.value;
        const fp = { ...this.state.featureParams };
        fp.defaultValue = defaultValue;
        this.setState({ featureParams: fp });
        this.createFeature(fp);
    }

    //生成feature参数json字符串
    createFeature = (featureParams) => {

        try {
            let feature = JSON.stringify(featureParams);
            this.setState({
                feature: feature
            });
            this.props.onChange(feature);
        } catch (e) {
            console.log(e);
            message.error('生成控件配置参数出错！');
        }
    }

    render() {

        let width = this.state.width;
        let { widthType, patternTag, placeholder, required, defaultValue } = this.state.featureParams;

        return (
            <div id="textarea-setting-div">
                <Row type="flex">
                    <Col><div style={{ margin: "16px 0" }}>宽度</div></Col>
                </Row>
                <Row type="flex">
                    <Col>
                        <RadioGroup onChange={this.handleWidthRadioChange} name="widthradiogroup"
                            value={widthType}>
                            <Radio value={WidthType.DEFAULT}>
                                自适应
                            </Radio>
                            <Radio value={WidthType.RELATIVE}>
                                百分比
                            </Radio>
                            <Radio value={WidthType.FIXED}>
                                固定宽度
                            </Radio>
                        </RadioGroup>
                    </Col>
                    <Col>
                        {
                            widthType == WidthType.RELATIVE ?
                                <InputNumber size="small"
                                    min={minWidth}
                                    formatter={value => `${value}%`}
                                    parser={value => value.replace('%', '')}
                                    onChange={this.handleWidthChange}
                                    value={width} />
                                : (
                                    widthType == WidthType.FIXED ?
                                        <InputNumber size="small"
                                            min={minWidth}
                                            formatter={value => `${value}px`}
                                            parser={value => value.replace('px', '')}
                                            onChange={this.handleWidthChange}
                                            value={width} />
                                        : null
                                )
                        }
                    </Col>
                </Row>
                {/* <Row type="flex">
                    <Col><div style={{ margin: "16px 0" }}>是否必填</div></Col>
                </Row>
                <Row type="flex">
                    <Col>
                        <RadioGroup onChange={this.handleRequiredRadioChange} name="requiredradiogroup"
                            value={required}>
                            <Radio value={false}>
                                非必填
                            </Radio>
                            <Radio value={true}>
                                必填
                            </Radio>
                        </RadioGroup>
                    </Col>
                </Row> */}
                <Row type="flex">
                    <Col><div style={{ margin: "16px 0" }}>正则校验</div></Col>
                </Row>
                <Row type="flex">
                    <Col span={12}>
                        <Select style={{ width: '100%' }} defaultValue={patternTag} onChange={this.handleRegularChange}>
                            {this.state.selectOptions}
                        </Select>
                    </Col>
                </Row>
                <Row type="flex">
                    <Col><div style={{ margin: "16px 0" }}>输入提示 | 默认值</div></Col>
                </Row>
                <Row type="flex">
                    <Col span={13}>
                        <Input placeholder="请输入字段预期值的提示信息" onChange={this.handlePlaceholderChange} value={placeholder} />
                    </Col>
                    <Col span={11}>
                        <Input placeholder="请输入默认值" onChange={this.handleDefaultValueChange} value={defaultValue} />
                    </Col>
                </Row>
            </div>
        )
    }
}

export default SettingTextArea;


// WEBPACK FOOTER //
// ./components/common/NHInputPicker/setting-textarea.js